import Cookies from 'js-cookie'
import authFetchHandler from './authFetchHandler'

const getRedirectURL = async () => {
  const queryString = window.location.search
  if (!queryString) {
    return
  }

  const urlParams = new URLSearchParams(queryString)
  const leaveQuery = urlParams.get('redirect')?.toLowerCase()
  if (leaveQuery && leaveQuery.includes('n')) {
    return
  }

  let returnQuery = urlParams.get('returnTo')?.toLowerCase()
  if (!returnQuery) {
    returnQuery = urlParams.get('r')?.toLowerCase()
  }
  if (returnQuery === 'community.firialabs.com') {
    const sso = urlParams.get('sso')
    const sig = urlParams.get('sig')
    const resp = await authFetchHandler(`session/discourse?sso=${sso}&sig=${sig}`)
    const json = await resp.json()
    return json?.redirectUrl
  }

  if (returnQuery) {
    if (returnQuery.includes('http')) {
      // Assuming this is a full URL/UCI
      return decodeURIComponent(returnQuery)
    } else if (returnQuery.includes(':')) {
      // This is probably localhost because it includes a port
      return `//${returnQuery}/`
    } else if (returnQuery.includes('.') || returnQuery.includes('/')) {
      // Assuming this is also a full URL/URI but without a protocol
      return `https://${returnQuery}/`
    } else {
      // Assuming this is a subdomain of firialabs.com
      return `https://${returnQuery}.firialabs.com/`
    }
  }
}

// Firebase Hosting's CDN strips every cookie except `__session` before
// forwarding to Cloud Functions. When redirecting to a Firia MCP OAuth
// callback, mirror the portal's session cookie under the `__session` name
// on the shared `firialabs.com` domain so the MCP callback can read it.
// The MCP callback clears the cookie on its outbound 302, so it only
// persists for the ~2s redirect window. Other redirect targets are
// untouched — this is MCP-only.
const maybeSetMcpSessionBridge = (redirectURL) => {
  if (!redirectURL || !redirectURL.includes('/mcp/callback')) {
    return
  }
  const runningLocally = (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === ''
  )
  const cookieName = window.location.hostname.startsWith('dev-') ?
    'dev-FiriaSimSessionCookie' :
    'FiriaSimSessionCookie'
  const sessionId = Cookies.get(cookieName)
  if (!sessionId) {
    return
  }
  Cookies.set('__session', sessionId, {
    domain: runningLocally ? 'localhost' : 'firialabs.com',
    path: '/',
    sameSite: 'Lax',
    secure: true,
    // no `expires` → session cookie, dies with browser
  })
}

const handleLoginPortalRedirect = async () => {
  const redirectURL = await getRedirectURL()
  if (redirectURL) {
    maybeSetMcpSessionBridge(redirectURL)
    setTimeout(() => {
      window.location.href = redirectURL
    }, 2000)
  }
}

export default handleLoginPortalRedirect